export interface SalaryScaleResponse {
  valid: ValidString;
  salaryNr: number;
  claId: number;
  flags: SalaryScalesFlag[];
  scale: string;
  periodSalary: number;
  salaryId: number;
  claCode: string;
  seniority: number;
}

export interface ValidString {
  from: string;
  to: string;
}

export enum SalaryScalesFlag {
  BUH_BLOCKED = 'BUH_BLOCKED',
  BONUS_BLOCKED = 'BONUS_BLOCKED'
}

export interface SalaryScaleFormValues
  extends Omit<
    SalaryScaleResponse,
    'valid' | 'flags' | 'periodSalary' | 'seniority' | 'salaryNr'
  > {
  valid: ValidDate;
  flags: SalaryScalesFlagForm;
  periodSalary: number | null;
  seniority: number | null;
  salaryNr: number | null;
}

export interface ValidDate {
  from: Date | null;
  to: Date | null;
}

export type SalaryScalesFlagForm = {
  BUH_BLOCKED: boolean;
  BONUS_BLOCKED: boolean;
};

export interface SalaryScalePostRequest
  extends Omit<SalaryScaleFormValues, 'valid' | 'flags'> {
  valid: {
    from: string | null;
    to: string | null;
  };
  flags: string[];
}

export interface CLAOption {
  code: string;
  claId: number;
  claSvc?: string;
  cla_ext: string;
}

export interface SalaryScalePutRequest extends SalaryScalePostRequest {
  salaryId: number;
}
